import React from "react";
import { Button, Icon, Loader } from "semantic-ui-react";
import PropTypes from "prop-types";

/**
 * TimetableControls: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Component that holds the timetable date controls
 * and activity indicator
 *
 * @param {*} props
 */
const TimetableControls = props => (
  <div className="ag-timetable-controls">
    {props.isLoading ? <Loader active inline /> : null}
    <Button onClick={props.onPrevWeek}>
      <Icon name="arrow left" />
    </Button>
    <Button onClick={props.onNextWeek}>
      <Icon name="arrow right" />
    </Button>
  </div>
);

TimetableControls.propTypes = {
  /**
   * onPrevWeek: (event, sender) => ()
   * Fired when the user clicks on the back button
   */
  onPrevWeek: PropTypes.func.isRequired,
  /**
   * onNextWeek: (event, sender) => ()
   * Fired when the user clicks on the forward button
   */
  onNextWeek: PropTypes.func.isRequired,
  /**
   * isLoading: Boolean
   * If true, displays the activity indicator.
   */
  isLoading: PropTypes.bool.isRequired
};

export default TimetableControls;



// WEBPACK FOOTER //
// ./src/modules/agenda/timetable/TimetableControls.js